import { render } from "./button2.vue?vue&type=template&id=5178508c&scoped=true&ts=true"
import script from "./button2.vue?vue&type=script&lang=ts"
export * from "./button2.vue?vue&type=script&lang=ts"

import "./button2.vue?vue&type=style&index=0&id=5178508c&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5178508c"]])

export default __exports__